import type { PropsWithChildren } from "react";
import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import { Loading } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./PageLoadingScreen.module.scss";

export interface PageLoadingScreenComponentProps {
  className: string;
  isLoading?: boolean;
  backgroundImage?: string;
  text?: string;
  subtitle?: string;
}
export const PageLoadingScreen = ({
  isLoading = false,
  className,
  children,
  text = "",
  subtitle,
  backgroundImage = "",
}: PropsWithChildren<PageLoadingScreenComponentProps>) => {
  const styles = useUiStyles(CoreUiComponents.PageLoadingScreen, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.PageLoadingScreen);

  return isLoading ? (
    // Announce the loading message to screen readers (WCAG 4.1.3).
    <div className={clsx(block, className)} role="status" aria-live="polite">
      <div
        className={cn("image")}
        style={{ backgroundImage: `url('${backgroundImage}')` }}
      />
      <div className={cn("icon")}>
        <Loading />
      </div>
      {text && <div className={cn("text")}>{text}</div>}
      {subtitle && <div className={cn("subtitle")}>{subtitle}</div>}
      {children}
    </div>
  ) : null;
};
